export default __webpack_public_path__ + "static/media/brain.d394bac7.mp4";